module.exports = {
  QuickEntry: 'ทางลัด',
  LastRefreshTime: 'ข้อมูลอัปเดตล่าสุดเมื่อ',
  SopBoard: 'กระดาน SOP',
  SeaExport: 'ส่งออกทางทะเล',
  SeaImport: 'นำเข้าทางทะเล',
  AirExport: 'ส่งออกทางอากาศ',
  AirImport: 'นำเข้าทางอากาศ',
  RailwayExport: 'ส่งออกทางรถไฟ',
  RailwayImport: 'นำเข้าทางรถไฟ',
  IntegratedJob: 'โลจิสติกส์แบบบูรณาการ',
  BusinessVolumeGraph: 'กราฟปริมาณงาน',
  PackUp: 'ย่อ',
  Unfold: 'ขยาย',
  SopReveal: 'แสดง SOP',
  SopFilterConditions: 'เงื่อนไขการกรอง SOP',
  SaveSucceed: 'บันทึกสำเร็จ',
  QuickEntryPopover: {
    FirstLine: '1.คุณสามารถลากฟังก์ชันใดๆ จากแถบเมนูมาที่ทางลัด',
    SecondLine: '2.เมื่อมีทางลัดมากเกินไปจนแสดงไม่หมดในหนึ่งแถว จะแสดงแบบขึ้นบรรทัดใหม่อัตโนมัติ'
  },
  SopBoardPopover: {
    FirstLine: '1.แผง SOP จะนับเฉพาะงานที่คุณสามารถดูได้ และแสดงเฉพาะโหนดและสถานะที่คุณเลือก',
    SecondLine: '2.业务的节点状态变成“已完成”后就不会出现在此节点中。',
    ThirdLine: '3.เมื่อเลื่อนเคอร์เซอร์ไปเหนือโหนด จะแสดงสถานะที่คุณเลือกในโหนดนี้ และจำนวนงานที่เกี่ยวข้อง',
    FourthLine: '4.คลิกที่โหนดหรือสถานะเพื่อไปยังฟังก์ชันงานที่เกี่ยวข้องและค้นหางานที่เกี่ยวข้อง'
  },
  LineChartPopover: {
    FirstLine: '1.กราฟปริมาณงานแสดงเฉพาะจำนวนงานใหม่ที่เกี่ยวข้องกับคุณใน 7 วันที่ผ่านมา'
  },
  SopFilterContent: {
    SopFilterConditionsTip: 'งานที่ตรงกับเงื่อนไขใดเงื่อนไขหนึ่งต่อไปนี้จะถูกนับในกระดาน SOP',
    BusinessState: 'ตามสถานะงาน',
    Operation: 'กำลังดำเนินการ',
    Submit: 'ส่งแล้ว',
    Audit: 'ตรวจสอบแล้ว',
    Date: 'ตามวันที่งาน',
    ETD: 'วันที่งาน (ETD) ไม่เร็วกว่า',
    ETA: 'วันที่งาน (ETA) ไม่เร็วกว่า',
    Days: 'วันก่อน',
    PleaseInputDays: 'กรุณากรอกจำนวนวัน',
    PleaseSelectBusinessType: 'กรุณาเลือกสถานะงานอย่างน้อยหนึ่งรายการ',
    PreCommit: 'เตรียมส่ง'
  },
  QuickEntryLayer: {
    FirstLine: '1.คลิกที่นี่เพื่อเข้าสู่ฟังก์ชันอย่างรวดเร็ว',
    SecondLine: '2.สามารถลากทางลัดออกจากเมนูได้โดยตรง'
  },
  SopBoardLayer: {
    FirstLine: '1.ที่นี่แสดงโหนด SOP ที่คุณสนใจ',
    SecondLine: '2.เลื่อนเมาส์เหนือโหนดเพื่อแสดงจำนวนงานในแต่ละสถานะภายใต้โหนดนั้น',
    ThirdLine: '3.โหนดและสถานะที่แสดงสามารถกำหนดได้อย่างอิสระ',
    FirstLine2: '1.ที่นี่แสดงรายการกระดานที่คุณสนใจ',
    SecondLine2: '2.คลิกรายการกระดานที่เกี่ยวข้องเพื่อแสดงข้อมูลที่เกี่ยวข้อง'
  },
  LineChartLayer: {
    FirstLine: '1.ที่นี่แสดงจำนวนงานใหม่ที่เกี่ยวข้องกับคุณใน 7 วันที่ผ่านมา',
    SecondLine: '2.สามารถนับแยกตามวันที่งานและวันที่สร้างงานได้'
  },
  SettingLayer: {
    FirstLine: 'คลิกปุ่มเฟืองเพื่อเข้าสู่หน้าตั้งค่าและปรับโหนดและสถานะที่แสดงในกระดาน SOP',
    SecondLine: 'ที่นี่แสดงเวลาอัปเดตข้อมูลล่าสุด'
  },
  NextStep: 'ขั้นตอนต่อไป',
  Loading: 'กำลังโหลดข้อมูล...',
  hasPermission: 'ขออภัย คุณไม่มีสิทธิ์',
  warningMessage: 'ข้อความเตือน',
  ignoreMessage: 'ละเว้นข้อความ',
  ignoreSelected: 'ละเว้นที่เลือก',
  restoreSelected: 'กู้คืนที่เลือก',
  ScreeningContent: 'กรองเนื้อหา:',
  Warning: 'การแจ้งเตือนล่วงหน้า',
  nodeName: 'ชื่อโหนด',
  nodeState: 'สถานะโหนด',
  warningLevel: 'ระดับการแจ้งเตือน',
  warningAt: 'เวลาการแจ้งเตือน',
  warningContent: 'เนื้อหาการแจ้งเตือน',
  sift: 'กรอง',
  toDoList: 'รายการสิ่งที่ต้องทำ',
  SopWarning: 'การแจ้งเตือน SOP',
  DelTrackingDetailConfirm: 'หมายเหตุ: จะลบรายละเอียดธุรกิจและโหนด SOP ที่เกี่ยวข้อง',
  DelTrackingConfirm: 'ต้องการลบโหนดนี้หรือไม่? เมื่อลบโหนดนี้แล้ว โหนดในเอกสารธุรกิจที่เกี่ยวข้องจะถูกลบพร้อมกัน',
  copyTrackingTemplateConfirm: 'ต้องการคัดลอกเทมเพลต【{0}】หรือไม่?',
  SelectTheNode: 'เลือกโหนด',
  StatusType: 'ประเภทสถานะ',
  AutomaticTriggering: 'ทำงานอัตโนมัติ',
  ExternalEncoding: 'รหัสภายนอก',
  ReportTemplate: 'เทมเพลตรายงาน',
  SendNotifications: 'ส่งการแจ้งเตือน',
  NotSendNotifications: 'ไม่ส่งการแจ้งเตือน',
  InitialState: 'สถานะเริ่มต้น'
}
